import { useState } from "react";

type OrganizationIntegrations = {
  builddocs2: boolean;
};

const initialState: OrganizationIntegrations = {
  builddocs2: false,
};

export function useOrganizationIntegrations() {
  const [integrations, setIntegrations] =
    useState<OrganizationIntegrations>(initialState);

  const update = (
    integrationList: (keyof OrganizationIntegrations)[],
    state: boolean,
  ) => {
    setIntegrations((prevState) => {
      const updatedIntegrations = { ...prevState };
      integrationList.forEach((key) => {
        updatedIntegrations[key] = state;
      });
      return updatedIntegrations;
    });
  };

  return { integrations, update };
}
